export default "__VITE_ASSET__CE8NkMLL__"